import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const IconReactions: TIconComponent = props => (
    <Icon viewBox="0 0 16 16" {...props}>
        <path
            d="M9.98927 5.08405L5.61565 0.196614C5.37032 -0.065538 4.96399 -0.065538 4.71866 0.196614L0.3447 5.08405C-0.0399624 5.49461 0.241035 6.18271 0.793363 6.18271H2.71901V10.5H7.54796V6.18271H9.54094C10.0929 6.18271 10.3739 5.49461 9.98927 5.08405Z"
            fill="#95C11F"
        />
        <path
            d="M4.34471 10.9159L8.71848 15.8034C8.96382 16.0655 9.37016 16.0655 9.6155 15.8034L13.9893 10.9159C14.374 10.5054 14.0929 9.81729 13.5406 9.81729H11.6149V5.5H6.7861V9.81729H4.79338C4.24104 9.81729 3.96003 10.5054 4.34471 10.9159Z"
            fill="#FF0000"
        />
    </Icon>
);
